<template>

    <m-edit1/>

    <m-chat-tasks-1 v-bind='{...{"defaultCategory":null,"hideFilter":false,"defaultMode":"mine"},...{}}' :style='""' class="" ></m-chat-tasks-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mChatTasks1 from '@moeinmdn/miw-alpha-components/src/package/Chat/Tasks/ChatTasks1';

export default {
    name: 'HomeView',
    components: {mEdit1, mChatTasks1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
